import styled from 'styled-components';

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 17px 16px 24px;
  display: flex;
  flex-direction: column;

  @media only screen and (min-width: 960px) {
    width: 435px;
    min-height: 570px;
    padding: 16px 28px;
    align-items: flex-end;
  }
`;

export default ModalContainer;
